import {
  Box,
  Card,
  CardHeader,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";

import React, { useEffect, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { Link, useHistory, useParams } from "react-router-dom";
import * as DocumentArticleService from "../../../service/DocumentArticleService";

export default function DocumentItem() {
  const [content, setContent] = useState("");
  const [tocLinks, setTocLinks] = useState([]);
  const [data, setData] = useState(null);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    DocumentArticleService.getById(id).then((data) => {
      setData(data);
      generateAnchorsAndTOC(data.content);
    });
  }, []);

  const generateAnchorsAndTOC = (doc) => {
    // Criamos um contêiner temporário para manipular o HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = doc;

    let h1Counter = 0;
    let h2Counter = 0;
    const headers = tempDiv.querySelectorAll("h1, h2"); // Seleciona todos os títulos e subtítulos
    const toc = [];

    headers.forEach((header) => {
      if (header.tagName.toLowerCase() === "h1") {
        h1Counter++;
        h2Counter = 0; // Reseta a numeração de subtítulos ao encontrar um novo título
        const anchorId = `title-${h1Counter}`;

        // Envolve o título com uma âncora real
        header.id = anchorId;

        toc.push({
          title: header.textContent || "Título",
          href: anchorId,
          number: `${h1Counter}`,
          isSubTitle: false, // Não é subtítulo
        });
      } else if (header.tagName.toLowerCase() === "h2") {
        h2Counter++;
        const anchorId = `subtitle-${h1Counter}-${h2Counter}`;
        header.id = anchorId;

        toc.push({
          title: header.textContent || "Subtítulo",
          href: anchorId,
          number: `${h1Counter}.${h2Counter}`,
          isSubTitle: true, // É subtítulo
        });
      }
    });

    setTocLinks(toc);
    setContent(tempDiv.innerHTML); // Limpeza do HTML para segurança
  };

  const scrollToAnchor = (anchor, event) => {
    event.preventDefault(); // Previne o comportamento padrão do link de navegação
    const element = document.getElementById(anchor);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box>
      <Card>
        <CardHeader
          title={
            <Box
              style={{
                padding: "1px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FiArrowLeft
                className="mr-2"
                size="22"
                color="gray"
                style={{ verticalAlign: "middle", cursor: "pointer" }}
                onClick={() => history.push("/document")}
              />
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                {data && `${data.sectionTitle} - ${data.title}`}
              </Typography>
            </Box>
          }
        />
      </Card>
      <Grid container spacing={2} style={{ marginTop: "10px" }}>
        <Grid item xs={9}>
          <Paper elevation={3} style={{ padding: "20px" }}>
            <div
              className="main-content"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper
            elevation={3}
            style={{
              padding: "20px",
              position: "sticky",
              top: "80px",
              borderRadius: "8px", // Added border radius for softness
            }}
          >
            <List>
              {tocLinks.map((link, index) => (
                <ListItem
                  key={index}
                  style={{
                    marginLeft: link.isSubTitle ? "20px" : "0",
                    transition: "background-color 0.2s", // Smooth transition for hover effect
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e0e0e0")
                  } // Hover effect
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <ListItemText>
                    <Link
                      href={`#${link.href}`}
                      onClick={(event) => scrollToAnchor(link.href, event)}
                      color="textPrimary"
                      style={{
                        textDecoration: "none", // Remove underline from link
                        fontWeight: "500", // Slightly bolder font
                      }}
                    >
                      {link.number} {link.title}
                    </Link>
                  </ListItemText>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
